import { render, staticRenderFns } from "./ChenLieNav.vue?vue&type=template&id=27df9ede&scoped=true&"
import script from "./ChenLieNav.vue?vue&type=script&lang=js&"
export * from "./ChenLieNav.vue?vue&type=script&lang=js&"
import style0 from "./ChenLieNav.vue?vue&type=style&index=0&id=27df9ede&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df9ede",
  null
  
)

export default component.exports